"use client";

import { ArrowUpRight01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Button } from "@matsuricon/ui/button";
import { useVolunteerRegistration } from "./volunteer-registration-provider";

export function VolunteerRegistrationControl({ label, className }: { label: string; className: string }) {
  const { registration, view, checkBeforeNavigation } = useVolunteerRegistration();
  if (!view.open || !registration.url) {
    return (
      <Button size="lg" className={className} disabled>
        {view.disabledLabel}
      </Button>
    );
  }

  return (
    <Button asChild size="lg" className={className}>
      <a
        href={registration.url}
        rel="noopener noreferrer"
        target="_blank"
        onClick={checkBeforeNavigation}
        onAuxClick={checkBeforeNavigation}
      >
        {label}
        <HugeiconsIcon data-icon="inline-end" aria-hidden="true" icon={ArrowUpRight01Icon} strokeWidth={2} />
        <span className="sr-only"> (opens in a new tab)</span>
      </a>
    </Button>
  );
}
